"use client";

import React from "react";
import "../privacy-policy/PrivacyPolicy.scss";
import Link from "next/link";
import { ReactSVG } from "react-svg";

const ShippingPolicy = () => {
  return (
    <div className='PrivacyPolicy-wrapper'>
      <div className='PrivacyPolicy-header-wrapper baseContainer'>
        <div className='maxWidth'>
          <div className='breadcrumbs-wrapper'>
            <Link
              href={"/"}
              className='text-xsmall-18 grey-100 weight-600'
              style={{ opacity: 0.5 }}>
              HOME
            </Link>
            <ReactSVG src='/assets/next-arrow-small-ic.svg' />
            <p className='text-xsmall-18 white weight-700'>SHIPPING POLICY</p>
          </div>
          <p className='section-main-header large white'>Shipping Policy</p>
        </div>
      </div>

      <div className='PloicyBody baseContainer'>
        <div className='maxWidth'>
          <div className='wrapper'>
            <div className='left'>
              <p className='text-medium-28  weight-600 black'>Content</p>
              <div className='links'>
                <Link href='/shipping-policy#1'>
                  <p className='text-mini-14 weight-500'>In-Store Pickup</p>
                </Link>
                <Link href='/shipping-policy#2'>
                  <p className='text-mini-14 weight-500'>Deliveries</p>
                </Link>
                <Link href='/shipping-policy#3'>
                  <p className='text-mini-14 weight-500'>General Information</p>
                </Link>
              </div>
            </div>
            <div className='right'>
              <div className='textBlock'>
                <div className='textWrapper' id='1'>
                  <p className='title weight-700'>In-Store Pickup</p>
                  <p className='desc'>
                    In-store pickup is available during our store hours: Monday to
                    Friday, 7:30 AM to 5:30 PM and Saturday 8:00 AM to 4:00 PM.
                  </p>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Order Processing:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Orders placed before 3:00 PM will be ready for pickup the
                        same day.
                        <br />
                      </li>
                      <li>
                        Orders placed after 3:00 PM will be ready for pickup the
                        next business day.
                        <br />
                      </li>
                      <li>
                        You will receive an email or text notification when your
                        order is ready for pickup.
                        <br />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Pickup Procedure:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Visit our store at 1500 Alma Street, Amherstburg, during
                        business hours.
                      </li>
                      <li>
                        Present your order confirmation email or ID at the
                        customer service desk.
                      </li>
                      <li>
                        Our staff will assist you with retrieving your order.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper' id='2'>
                  <p className='title weight-700'>Deliveries</p>
                  <p className='desc black weight-700'>Service Areas:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        We deliver within a 100km radius of our store located at
                        1500 Alma Street, Amherstburg
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Delivery Schedule:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Deliveries are made Monday to Friday, between 7:00 AM and
                        3:00 PM.
                      </li>
                      <li>
                        Same-day deliveries cannot be guaranteed; however, we will
                        make every effort to accommodate it if we can.
                      </li>
                      <li>
                        Orders placed before 12:00 PM will be delivered the next
                        business day.
                      </li>
                      <li>
                        Orders placed after 12:00 PM will be delivered within two
                        business days.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Delivery Fees:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Our delivery fee begins at $50 and increases based on
                        distance, product handling, and special instructions.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Delivery Procedure:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        We strive to place materials in the requested area
                        whenever possible.
                      </li>
                      <li>
                        If obstructions could cause damage, we will find the
                        safest alternative location.
                      </li>
                      <li>
                        A signature is required upon delivery. If a signature
                        cannot be provided, we will take a photo as proof of
                        delivery.
                      </li>
                      <li>
                        We will promptly inform you of any issues or delays during
                        delivery.
                      </li>
                      <li>
                        Any discrepancies or damages will be reported immediately.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper' id='3'>
                  <p className='title weight-700'>General Information</p>
                  <p className='desc black weight-700'>Order Tracking:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        You can track your order status through our website or by
                        contacting our customer service team at{' '}
                        <Link
                          href="tel:5197139318"
                          className="text-medium-24  blue-500"
                          style={{ cursor: 'pointer' }}
                        >
                          (519) 713-9318
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Returns and Exchanges:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Please refer to our{' '}
                        <Link className="text-medium-24  blue-500" style={{ cursor: 'pointer' }} href="/refund-policy">Refunds</Link> page for information on
                        returns and exchanges. In-store returns are accepted
                        during business hours.{" "}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='desc black weight-700'>Customer Service:</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        For any questions or concerns regarding your order, please
                        contact our customer service team at{' '}
                        <Link
                          href="mailto:hello@amherstsupply.com"
                          className="text-medium-24  blue-500"
                          style={{ cursor: 'pointer' }}
                        >
                          hello@amherstsupply.com
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <br />
                  <p className='desc black weight-700'>
                    Thank you for choosing Amherst Supply for your building needs.
                    We strive to provide exceptional service and ensure your
                    satisfaction with every order.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
